import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxOpen , faUserFriends , faClock} from '@fortawesome/free-solid-svg-icons'
import ShareIcon from '@material-ui/icons/Share';
import BookmarkBorder from '@material-ui/icons/BookmarkBorder';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { Link } from 'react-router-dom';

import img from '../../../images/ux.png';
import bookmark from './images/border-bookmark.png';

export default class cardInterview extends Component {
    render() {
        const theme = createMuiTheme({
            palette: {
                primary: { main: '#E85A19', light: '#E85A19', dark: '#E85A19' },
                secondary: { main: '#fbb800', light: '#000', dark: '#f1eeee' },
                contrastText: { main: '#E1631C' },
            }
        })
        return (
            <ThemeProvider theme={theme}>
                <div className="pt-3 pb-3">
                    <Row className="justify-content-center">
                        <Col md={3} xs={7} className="order-sm-1 order-2 text-center p-0">
                                <img src={img} alt="interview img" className="w-75 text-left mb-3" />
                        </Col>
                        <Col md={9} xs={12} className="order-sm-2 order-3 text-left">
                            <Row className="m-0">
                            <Col md='8' className="order-sm-1 order-2 p-0  d-inline-block">
                                <h5>UX/UI Designer</h5>
                                <p className="text-orange d-inline-block pr-1">New Horizon </p>
                                <p className="text-grey d-inline-block"> 13 Nov 2019</p>
                                <p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumyt <Link to="/" className="text-orange underline">See More</Link></p>
                            </Col>
                            <Col md='4' className="text-center order-sm-2 p-0 order-1 mb-1 d-inline-block text-responsive-right">
                                <Button variant="outlined" className="btn-orange-outline-gradiant" color="primary">
                                    <ShareIcon /> share
                                </Button>
                                <Link className="pl-3">
                                    <img src={bookmark} className="btn-bookmark" width="20" alt="bookmark"/>
                                </Link> 
                            </Col>
                            </Row>
                            <Row className="pt-1 m-0">   
                                <Col className="text-left text-center-sm p-0">
                                        <FontAwesomeIcon icon={faUserFriends} size="lg" className="text-grey"/>
                                        <span className="pl-1">32 Applicant</span>
                                </Col>
                                <Col  className="text-left text-center-sm p-0">
                                        <FontAwesomeIcon icon={faBoxOpen} size="lg" className="text-grey"/>
                                        <span className="pl-1">15 Question</span>
                                </Col>
                                <Col  className="text-left text-center-sm p-0">
                                        <FontAwesomeIcon icon={faClock} size="lg" className="text-grey"/>
                                        <span className="pl-1"> 15 Min</span>
                                </Col>
                                <Col xs={12} className=" text-center-sm text-left p-0">
                                    <p className="p-0 mb-2 mt-2">Tools</p>
                                    <Button className="mr-1" variant="outlined" disabled>
                                        Adobe XD
                                    </Button>
                                    <Button className="mr-1" variant="outlined" disabled>
                                        Graphic design
                                    </Button>
                                    <Button className="mr-1" variant="outlined" disabled>
                                        Design
                                    </Button>
                                    <Button className="mr-1" variant="outlined" disabled>
                                        Figma
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </ThemeProvider>
        );
    }
}